var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.049,
    height: 37.289,
    viewBox: "0 0 92.049 37.289",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:rgba(70,54,9,.25)}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__audio",
    transform: "translate(0 -36.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_3",
    d: "M1.534 371.905a1.412 1.412 0 0 0 1.534-1.243v-2.486a1.412 1.412 0 0 0-1.534-1.243A1.412 1.412 0 0 0 0 368.176v2.486a1.412 1.412 0 0 0 1.534 1.243zm0 0",
    className: "prefix__cls-1",
    "data-name": "Path 3",
    transform: "translate(0 -314.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_4",
    d: "M28.67 364.613v-4.972a1.568 1.568 0 0 0-3.068 0v4.972a1.568 1.568 0 0 0 3.068 0zm0 0",
    className: "prefix__cls-1",
    "data-name": "Path 4",
    transform: "translate(-20.999 -307.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5",
    d: "M131.068 364.613v-4.972a1.568 1.568 0 0 0-3.068 0v4.972a1.568 1.568 0 0 0 3.068 0zm0 0",
    className: "prefix__cls-1",
    "data-name": "Path 5",
    transform: "translate(-104.988 -307.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6",
    d: "M62.8 352.519v-9.943a1.568 1.568 0 0 0-3.068 0v9.943a1.568 1.568 0 0 0 3.068 0zm0 0",
    className: "prefix__cls-1",
    "data-name": "Path 6",
    transform: "translate(-48.995 -292.758)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_7",
    d: "M96.935 352.519v-9.943a1.568 1.568 0 0 0-3.068 0v9.943a1.568 1.568 0 0 0 3.068 0zm0 0",
    className: "prefix__cls-1",
    "data-name": "Path 7",
    transform: "translate(-76.991 -292.758)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8",
    d: "M165.2 340.424v-14.915a1.568 1.568 0 0 0-3.068 0v14.915a1.568 1.568 0 0 0 3.068 0zm0 0",
    className: "prefix__cls-1",
    "data-name": "Path 8",
    transform: "translate(-132.984 -278.178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_9",
    d: "M199.334 328.33v-19.888a1.568 1.568 0 0 0-3.068 0v19.888a1.568 1.568 0 0 0 3.068 0zm0 0",
    className: "prefix__cls-1",
    "data-name": "Path 9",
    transform: "translate(-160.98 -263.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_10",
    d: "M233.467 292.046v-34.8a1.568 1.568 0 0 0-3.068 0v34.8a1.568 1.568 0 0 0 3.068 0zm0 0",
    className: "prefix__cls-1",
    "data-name": "Path 10",
    transform: "translate(-188.977 -219.856)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_11",
    d: "M496.467 366.934a1.412 1.412 0 0 0-1.534 1.243v2.486a1.568 1.568 0 0 0 3.068 0v-2.486a1.412 1.412 0 0 0-1.534-1.243zm0 0",
    className: "prefix__cls-1",
    "data-name": "Path 11",
    transform: "translate(-405.953 -314.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_12",
    d: "M472.4 364.613v-4.972a1.568 1.568 0 0 0-3.068 0v4.972a1.568 1.568 0 0 0 3.068 0zm0 0",
    className: "prefix__cls-1",
    "data-name": "Path 12",
    transform: "translate(-384.954 -307.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_13",
    d: "M370 364.613v-4.972a1.568 1.568 0 0 0-3.068 0v4.972a1.568 1.568 0 0 0 3.068 0zm0 0",
    className: "prefix__cls-1",
    "data-name": "Path 13",
    transform: "translate(-300.965 -307.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_14",
    d: "M438.267 352.519v-9.943a1.568 1.568 0 0 0-3.068 0v9.943a1.568 1.568 0 0 0 3.068 0zm0 0",
    className: "prefix__cls-1",
    "data-name": "Path 14",
    transform: "translate(-356.958 -292.758)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_15",
    d: "M404.135 352.519v-9.943a1.568 1.568 0 0 0-3.068 0v9.943a1.568 1.568 0 0 0 3.068 0zm0 0",
    className: "prefix__cls-1",
    "data-name": "Path 15",
    transform: "translate(-328.961 -292.758)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_16",
    d: "M335.869 340.424v-14.915a1.568 1.568 0 0 0-3.068 0v14.915a1.568 1.568 0 0 0 3.068 0zm0 0",
    className: "prefix__cls-1",
    "data-name": "Path 16",
    transform: "translate(-272.969 -278.178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_17",
    d: "M301.736 328.33v-19.888a1.568 1.568 0 0 0-3.068 0v19.888a1.568 1.568 0 0 0 3.068 0zm0 0",
    className: "prefix__cls-1",
    "data-name": "Path 17",
    transform: "translate(-244.972 -263.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_18",
    d: "M267.6 292.046v-34.8a1.568 1.568 0 0 0-3.068 0v34.8a1.568 1.568 0 0 0 3.068 0zm0 0",
    className: "prefix__cls-1",
    "data-name": "Path 18",
    transform: "translate(-216.976 -219.856)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.a20090bd9dcec01143d72504d4e746ad.svg";
export { ForwardRef as ReactComponent };